$(document).on("receipts#index:loaded", function() {
  $("#receipts_search input").keyup(function()
  {
    $.get($("#receipts_search").attr("action"), $("#receipts_search").serialize(), null, "script");
    return false
  });
});
